var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5008 11.5752L15.9236 14.9979L14.997 15.9246L11.5742 12.5018C10.3876 13.4816 8.86606 14.0704 7.2071 14.0704C3.41709 14.0704 0.344727 10.9981 0.344727 7.20807C0.344727 3.41807 3.41709 0.345703 7.2071 0.345703C10.9971 0.345703 14.0695 3.41807 14.0695 7.20807C14.0695 8.8671 13.4807 10.3887 12.5008 11.5752ZM7.2071 12.76C10.2734 12.76 12.7591 10.2743 12.7591 7.20807C12.7591 4.1418 10.2734 1.6561 7.2071 1.6561C4.14082 1.6561 1.65513 4.1418 1.65513 7.20807C1.65513 10.2743 4.14082 12.76 7.2071 12.76Z",
    fill: "black"
  })));
};
export default SvgSearchIcon;